export default {
  Click: {
    meta: {
      schemaId: 14044,
      schemaVersion: 1
    },
    data: {
      logCategory: 'event',
      logType: 'click'
    }
  },
  Impression: {
    meta: {
      schemaId: 14043,
      schemaVersion: 1
    },
    data: {
      logCategory: 'impression',
      logType: 'impression'
    }
  },
  PageView: {
    meta: {
      schemaId: 14042,
      schemaVersion: 1
    },
    data: {
      logCategory: 'view',
      logType: 'page',
      eventName: 'default page view'
    }
  },
}
